import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import TreeSliderInputField from './TreeSliderInputField';
import { convertFeetToMetric, convertMetricToFeet } from '../../util';
import { selectTreeState } from 'store/slices/TreeSlice/selector';
import { updateTree } from 'store/slices/TreeSlice';
import { TreeFieldItem } from './styles';

type Props = {
	isActive: boolean;
	onActivate: () => void;
	disabled?: boolean;
};

const MIN_DIAMETER = 0;
const SLIDER_MAX_DIAMETER = 65.6;
const INPUT_MAX_DIAMETER = 98.4;
const STEP = 1;

export default function TreeCrownDiameterField({ isActive, onActivate, disabled }: Props) {
	const dispatch = useDispatch();
	const { selectedTreeId, selectedTree } = useSelector(selectTreeState);
	const { groundMetersPerPixel } = useSelector((state: RootState) => state.roofData.data);

	if (!selectedTreeId || !selectedTree) return null;

	const toFeet = (pixels: number) => convertMetricToFeet(pixels * groundMetersPerPixel, 'm', 1);
	const toPixels = (feet: number) => convertFeetToMetric(feet, 'm', 6) / groundMetersPerPixel;

	const value = toFeet(selectedTree.crownRadius* 2);

	const updateValue = (next: number) => {
		const normalized = Number.isFinite(next) ? Math.max(MIN_DIAMETER, Math.min(INPUT_MAX_DIAMETER, next)) : MIN_DIAMETER;
		dispatch(updateTree({
			id: selectedTreeId,
			tree:{
				crownRadius: toPixels(normalized/2)
			}
		}));
	};

	return (
		<TreeFieldItem>
			<TreeSliderInputField
				id="tree-crown-diameter"
				label="Crown Diameter"
				value={value}
				min={MIN_DIAMETER}
				max={INPUT_MAX_DIAMETER}
				sliderMax={SLIDER_MAX_DIAMETER}
				step={STEP}
				unit="ft"
				isActive={isActive}
				onActivate={onActivate}
				onInputChange={updateValue}
				disabled={disabled}
				showSlider={true}
			/>
		</TreeFieldItem>
	);
}
